import { api } from "@";

// Fetch ratings data from the API
export const getRatings = (page = 1, pageSize = "") =>
  api.get(`/api/AdminOrder/orders-ratings?Page=${page}&PageSize=${pageSize}`);
